(ns iris.styles.simple-modal
  (:require
;;    [herb.core :refer [<class <id]]
   ;; [garden.units :refer [px]]
   [shadow.css :refer [css]]
   ))



(def $modal
  (css {:display "block"
        :position "fixed"
        :z-index "100001"
        :left "0"
        :top "0"
        :width "100%"
        :height "100%"
        :overflow "auto"
        :background-color "rgba(0,0,0,0.4)"}))


(def $modal-content
  (css {:position "absolute"
        :top "50%"
        :left "50%"
        :transform "translate(-50%, -50%)"
        :width "90%"
        :max-height "90%"
        :overflow-y "auto"
        :background-color "#fefefe"
        :padding "0"
        :border "1px solid #888"}))

;; The Close Button
(def $close-btn
  (css {:line-height "normal"
        :color "#aaa"
        :float "right"
        :font-size "28px"
        :font-weight "bold"
        :width "40px"
        :height "100%"
        :text-align "center"
        :border-left "solid 1px lightgrey"}
       [:hover {:color "black"
                :text-decoration "none"
                :cursor "pointer"}]))

(def $top-bar
  (css {:height "40px"
        :border "solid 1px lightgrey"
        :background-color "#f1f1f1"
        :text-align "center"}))

(def $title
  (css {:display "inline-block"
        :line-height "40px"
        :font-weight "bold"
        :color "#333"}))

(def $child-content
  (css {:padding "15px"}))

;; The Modal (background)
;; (defn modal [display]
;;   {:display (if (true? display) "block" "none")
;;    :position "fixed"
;;    :z-index "100001"
;;    :left 0
;;    :top 0
;;    :width "100%"
;;    :height "100%"
;;    :overflow "auto"
;; ;;    :background-color "rgb(0,0,0)"
;;    :background-color "rgba(0,0,0,0.4)"})

;; Modal Content/Box
;; (defn modal-content [width]
;;   {:position "absolute"
;;    :top "50%"
;;    :left "50%"
;;    :transform "translate(-50%, -50%)"
;;    :width "90%"
;;    :max-width (str width "px")
;;    :max-height "90%"
;;    :overflow-y "auto"
;;    :background-color "#fefefe"
;;    :padding 0
;;    :border "1px solid #888"})


;; The Close Button
;; (defn close-btn []
;;   ^{:pseudo {:hover {:color "black"
;;                      :text-decoration "none"
;;                      :cursor "pointer"}}}
;;   {:line-height "normal"
;;    :color "#aaa"
;;    :float "right"
;;    :font-size "28px"
;;    :font-weight "bold"
;;    :width "40px"
;;    :height "100%"
;;    :text-align "center"
;;    :border-left "solid 1px lightgrey"})


;; (defn top-bar []
;;   {:height "40px"
;;    :border "solid 1px lightgrey"
;;    :background-color "#f1f1f1"
;;    :text-align "center"})


;; (defn title []
;;   {:display "inline-block"
;;    :line-height "40px"
;;    :font-weight "bold"
;;    :color "#333"})


;; (defn child-content []
;;   {:padding "15px"})